var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pb-5" }, [
    _c(
      "div",
      { staticClass: "container container-small mb-3" },
      [
        _c("Heading", {
          staticClass: "py-4",
          attrs: { title: _vm.$t("add_profile_title") },
        }),
        _c("BillingProfile", {
          attrs: { errorMsgs: _vm.errorMsgs },
          on: {
            input: function ($event) {
              return _vm.updateProfileFromComponent($event)
            },
            resetErrors: _vm.resetErrorMsgs,
          },
        }),
        _c("div", { staticClass: "text-center mt-4" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-purple w-100",
              on: {
                click: function ($event) {
                  return _vm.addProfile()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("btn_save")))]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }